import { render, staticRenderFns } from "./NewsletterSignup.vue?vue&type=template&id=081e0806&"
import script from "./NewsletterSignup.vue?vue&type=script&lang=js&"
export * from "./NewsletterSignup.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterSignup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports